import { Component} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { ViewActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/view.component';

@Component({
    selector: 'app-kyc-view',
    templateUrl: './kyc-view.component.html',
    styleUrls: ['./kyc-view.component.scss']
})

export class KycViewComponent {
    private gridApi!: GridApi;
    private gridColumnApi!: ColumnApi;
    public context: any;

    defaultColDef = {
        filter: true,
        sortable: true,
        resizable: true,
    };
    rowData = [{doctype: '', concatenated_urlpath: ''}];

    gridOptions: GridOptions = {
        pagination: true,
        paginationPageSize: 10,
        domLayout: 'autoHeight',
    };

    columnDefs = [
        { headerName: 'Document Type', field: 'doctype', flex: 1},
        { headerName: 'View', field: 'concatenated_urlpath',  cellRenderer: ViewActionsRenderer, flex: 1 }
    ]
    constructor(
        public activeModal: NgbActiveModal,
    ) {
        this.context = { componentParent: this }
    }

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.setDomLayout("autoHeight");
    }

    viewAction(data: any) {
        if (data.concatenated_urlpath) {
            window.open(data.concatenated_urlpath, '_blank');
        } else {
            console.error('File URL is missing');
        }
    }
    
}
